import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { MerchantRentalYourspacePage } from './merchant-rental-yourspace';

@NgModule({
  declarations: [
    MerchantRentalYourspacePage,
  ],
  imports: [
    IonicPageModule.forChild(MerchantRentalYourspacePage),
    TranslateModule.forChild()
  ],
})
export class MerchantRentalYourspacePageModule {}



// WEBPACK FOOTER //
// ./src/pages/merchant-rental-yourspace/merchant-rental-yourspace.module.ts